module.exports = __webpack_public_path__ + "img/echo-logo-white.51a36574.jpg";